import { get } from "axios"

const getAllEquipment = (busqueda, pagina) => {
    const token = localStorage.getItem('token');
    return (
        get(`${process.env.REACT_APP_URL_API}equipment?bus=${busqueda}&pag=${pagina}`, {
            headers: {
                'Authorization': `Bearer ${token}`  // Incluye el token JWT en el encabezado
            }
        })
            .then(response => {
                const { data } = response
                return data
            })
            .catch(error => {
                console.log(error)
            })
    )
}
export default getAllEquipment